import React from 'react';

import {svgIconWrapper} from '../svg-icon-wrapper';

import HtmlAttachment from './html-attachment-icon.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <HtmlAttachment {...validProps} />;
}
SvgComponent.iconName = 'htmlAttachment';

export const HtmlAttachmentIcon = svgIconWrapper(SvgComponent);
